import React, { createContext, useContext, useState } from 'react';

const ScreenBuilderContext = createContext();

export const useScreenBuilder = () => useContext(ScreenBuilderContext);

export const ScreenBuilderProvider = ({ children }) => {
  const [resetScreensCallback, setResetScreensCallback] = useState(null);
  const [devModeEnabled, setDevModeEnabled] = useState(() => {
    if (typeof window === 'undefined') return false;
    const stored = window.localStorage.getItem('dev_mode_enabled');
    return stored === 'true';
  });
  const [devJsonPayload, setDevJsonPayload] = useState(() => {
    if (typeof window === 'undefined') return '';
    return window.localStorage.getItem('dev_json_payload') || '';
  });
  const [expertModeEnabled, setExpertModeEnabled] = useState(() => {
    if (typeof window === 'undefined') return false;
    const stored = window.localStorage.getItem('expert_mode_enabled');
    return stored === 'true';
  });

  const resetScreens = () => {
    if (resetScreensCallback) {
      resetScreensCallback();
    }
  };

  const updateDevModeEnabled = (val) => {
    setDevModeEnabled(val);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('dev_mode_enabled', val ? 'true' : 'false');
    }
  };

  const updateDevJsonPayload = (val) => {
    setDevJsonPayload(val);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('dev_json_payload', val || '');
    }
  };

  const updateExpertModeEnabled = (val) => {
    setExpertModeEnabled(val);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('expert_mode_enabled', val ? 'true' : 'false');
    }
  };

  return (
    <ScreenBuilderContext.Provider value={{
      resetScreens,
      setResetScreensCallback,
      devModeEnabled,
      setDevModeEnabled: updateDevModeEnabled,
      devJsonPayload,
      setDevJsonPayload: updateDevJsonPayload,
      expertModeEnabled,
      setExpertModeEnabled: updateExpertModeEnabled
    }}>
      {children}
    </ScreenBuilderContext.Provider>
  );
};
